/*
 * @format
 * @flow
 */
import { isEmpty } from 'lodash';
import permitConfig from '../../dev/permit.config';
import {
  type PermitConfigType,
  type ComponentsType,
  type Rail,
  type PermitTypes,
} from '../types/permit.config';
import { PERMIT_TYPE_LIST } from '../constants';

const DOGS_PET_LABEL = 'Dogs or other pets';

export function getPermitConfig(permitId: string): PermitConfigType {
  const permitConfigObj = permitConfig[permitId];
  return permitConfigObj ?? {};
}

export function getComponents(permitId: string): Array<ComponentsType> {
  return getPermitConfig(permitId).components ?? [];
}

export function getLotteryComponents(permitId: string): Array<ComponentsType> {
  return getPermitConfig(permitId).lotteryComponents ?? [];
}

export function getComponentSettings(permitId: string, ComponentName: ComponentsType) {
  return (
    getComponents(permitId).find((component) => {
      return typeof component === 'object' && component.name === ComponentName;
    }) ?? {}
  );
}

export function getSidebarElements(permitId: string): Array<Rail> {
  return getPermitConfig(permitId).pages?.Venue?.rightRail ?? [];
}

export function getAvailabilityConfig(permitId: string) {
  return getPermitConfig(permitId).pages?.DetailedAvailability ?? {};
}

export function getPermitTypeList(permitId: string): Array<PermitTypes> {
  const permitTypeList = getAvailabilityConfig(permitId).permitTypes ?? [];
  return permitTypeList.length ? permitTypeList : [PERMIT_TYPE_LIST.default];
}

export function getAnimalLabel(permitId: string): string {
  const component = getComponentSettings(permitId, 'AnimalDetail');
  if (typeof component !== 'string') {
    return component.animalsLabels?.[DOGS_PET_LABEL] ?? '';
  }
  return '';
}

export const hasLateArrivalQuestion = (permitId: string): boolean =>
  !!getPermitConfig(permitId)?.components?.find(
    (comp) => comp === 'LateArrivalQuestion' || comp?.name === 'LateArrivalQuestion'
  );

export const IS_LAND_PERMIT = (permitId: string): boolean =>
  !isEmpty(getPermitConfig(permitId));
